import React from "react";
import "../CSS/AktivitasTenagaKesehatan.css";
import { FaStethoscope, FaCheckCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

function ProfileTenagaKesehatan() {

  const navigate = useNavigate();

  const handleInformasiClick = () => {
    navigate("/DetailTenagaKesehatanProfile"); 
  };

  return (
    <div className="profile-page">
      <div className="main-contentprofile">
        <div className="content-profile">

          <div className="profile-card">
            <div className="profile-avatar">NK</div>
            <div className="profile-info">
              <h3>Dr. Megumi Fushiguro</h3>
              <p>Dokter Spesialis Paru - RSUD Magetan</p>
              <p className="nip">NIP. 45668989</p>
            </div>
          </div>

          <div className="tab-section">
            <button className="tab"  onClick={handleInformasiClick} >Informasi</button>
            <button className="tab active">Aktivitas</button>
          </div>


          {/* === CARD STATISTIK === */}
          <div className="stats-container">
            <div className="stat-card">
              <div className="icon-wrapper pasien">
                <FaStethoscope />
              </div>
              <div className="stat-info">
                <h2>20</h2>
                <p>Pasien Ditangani</p>
              </div>
            </div>

            <div className="stat-card">
              <div className="icon-wrapper terapi">
                <FaCheckCircle />
              </div>
              <div className="stat-info">
                <h2>85%</h2>
                <p>Keberhasilan Terapi</p>
              </div>
            </div>
          </div>


           <footer className="footerdebar">
          © 2025 TibiSmart. All rights reserved.
        </footer>


        </div>
      </div>
    </div>
  );
}

export default ProfileTenagaKesehatan;
